// Leftovers of the first version (19.10.2026 morning), which kept the Claude key in this browser's localStorage under
// brewcore.claude.<account>.key. The key now lives in the account (the cloud keeps it sealed); a key found here is
// offered once for the account ("Im Konto speichern") and then removed from this browser. Sign-out removes every
// brewcore.claude.* entry anyway. localStorage can be missing or throw (private mode): then there is nothing to find.

export interface KeyValueStorage {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
  key(index: number): string | null;
  readonly length: number;
}

export const AI_PREFIX = 'brewcore.claude.';
const LEGACY_KEY = /^brewcore\.claude\.[^.]+\.key$/;

export function browserStorage(): KeyValueStorage | null {
  try {
    return globalThis.localStorage ?? null;
  } catch {
    return null;
  }
}

/** A storage in memory (tests, the screen gallery). */
export function memoryStorage(seed: Record<string, string> = {}): KeyValueStorage {
  const m = new Map(Object.entries(seed));
  return {
    getItem: (k) => m.get(k) ?? null,
    setItem: (k, v) => void m.set(k, v),
    removeItem: (k) => void m.delete(k),
    key: (i) => [...m.keys()][i] ?? null,
    get length() {
      return m.size;
    },
  };
}

function keys(storage: KeyValueStorage): string[] {
  const out: string[] = [];
  for (let i = 0; i < storage.length; i++) {
    const k = storage.key(i);
    if (k?.startsWith(AI_PREFIX)) out.push(k);
  }
  return out;
}

/** A key the first version left in this browser (any account), or null. */
export function legacyKey(storage: KeyValueStorage | null = browserStorage()): string | null {
  if (!storage) return null;
  try {
    for (const k of keys(storage)) {
      if (!LEGACY_KEY.test(k)) continue;
      const v = JSON.parse(storage.getItem(k) ?? 'null') as unknown;
      if (typeof v === 'string' && /^sk-ant-[A-Za-z0-9_-]{8,}$/.test(v)) return v;
    }
  } catch {
    // unreadable: nothing to offer
  }
  return null;
}

/** Every entry of the Claude support of the first version in this browser (key, chats, suggestions, grinder). */
export function forgetClaudeOnDevice(storage: KeyValueStorage | null = browserStorage()): void {
  if (!storage) return;
  try {
    for (const k of keys(storage)) storage.removeItem(k);
  } catch {
    // blocked storage holds nothing
  }
}
